<template>
    <div style="background-color: #ffffff;position: relative">
        <quill-editor
                style="min-height: 120px"
                v-model="internalValue"
                ref="myQuillEditor"
                @change="onEditor($event)"
                :options="editorOption"/>
        <input id="contents2" @change="editorUploadSuccess"
               type="file"
               style="width: 1px;height: 1px;z-index: -1000"
               accept="image/*"/>
        <span style="position: absolute;bottom:0;right: 1rem;color: silver">{{tiLength}}/{{maxLength}}</span>
    </div>
</template>

<script>
    import service from "../api/service";
    import lrz from "lrz";

    const toolbarOptions =[['bold', 'italic', 'underline', 'strike'], [{'align': []}], ['image']]
    import {quillEditor} from 'vue-quill-editor';
    //新闻管理
    export default {
        name: "myEditor",
        components: {quillEditor},
        props: {
            //双向绑定值
            value: '',
            //最大字数
            maxLength: {
                type: Number,
                default: 200
            }
        },
        data() {
            return {
                tiLength: 0,
                editorOption: {
                    placeholder: '请输入内容',
                    modules: {
                        toolbar: {
                            container: toolbarOptions,  // 工具栏
                            handlers: {
                                'image': (value) => {
                                    if (value) {
                                        document.querySelector('#contents2').click()
                                    } else {
                                        this.quill.format('image', false);
                                    }
                                }
                            }
                        }
                    }
                },
            }
        },
        methods: {
            editorUploadSuccess(e) { // 富文本编辑器中图片上传成功回调
                // 此时可以自行将文件上传至服务器
                let formData = new FormData();
                // 获取文件对象
                let file = e.target.files[0];
                let fileName = file.name
                // 压缩前文件大小
                let imgUrl = URL.createObjectURL(file, {quality: 0});
                lrz(imgUrl).then(rst => {
                    // 压缩后文件大小
                    let fff = this.base64ToFile(rst.base64, fileName)
                    formData.append('file', fff)
                    formData.append('userName', 'userName')
                    service.post('/file-up/resources/import',
                        formData).then(res => {
                        if (res.status === 200) {
                            let url = service.baseURLB + res.data.fileUrl
                            let quill = this.$refs.myQuillEditor.quill
                            // 获取光标所在位置
                            let length = quill.getSelection().index;
                            // 插入图片 res.url为服务器返回的图片地址
                            quill.insertEmbed(length, 'image', (url))
                            // 调整光标到最后
                            quill.setSelection(length + 1)
                        }
                    })
                });
            },
            base64ToFile(dataurl, filename) {
                let arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type: mime});
            },
            onEditor(e) {
                e.quill.deleteText(this.maxLength, 4)
                if (this.value === '') {
                    this.tiLength = 0
                } else {
                    this.tiLength = e.quill.getLength() - 1
                }
            }
        },
        computed: {
            internalValue: {
                get() {
                    return this.value
                },
                set(v) {
                    this.$emit('input', v)
                }
            }
        }
    }
</script>

<style scoped>

</style>